const PREFIX = "events/";
export const SET_IS_DESKTOP = `${PREFIX}SET_IS_DESKTOP`;
export const SET_SCROLL_POSITION = `${PREFIX}SET_SCROLL_POSITION`;
export const RESTORE_SCROLL_POSITION = `${PREFIX}RESTORE_SCROLL_POSITION`;
